import $ from 'jquery';

$(document).ready(function () {

    const contactForm = $('form[name="contact"]');
    const subjectSelect = contactForm.find('select[name="contact[subject]"]');

    const initialSubjectHtml = subjectSelect.html();
    const contactTypeInput = contactForm.find('input[name="contact[contactType]"]');

    contactTypeInput.click(function (event) {

        /*
            On réinitialise le contenu de la div avec le contenu d'origine
            car on supprime des options dans la fonction showSubjectByCategory()
         */
        subjectSelect.html(initialSubjectHtml);
        const idToShow = $(event.currentTarget).val();

        $('.containContact').hide();
        $('.' + idToShow).slideDown();
        showSubjectByCategory(subjectSelect, idToShow);

    });


    subjectSelect.change(function () {
        $('.containMessageContact, .containEnvoiMessageContact, .containCopieMailContact, .containCaptchaContact').slideDown();
    });

    if (contactForm.find('input[name="contact[contactType]"]:checked').length > 0) {
        subjectSelect.change();
    }

    $('#telContact').keyup(function (event) {
        var $number = $(event.currentTarget);
        var number = $number.val().replace('_', '');

        if (number[0] === '0' && number[1] === '0') {
            $number.val('+' + number.substring(2));
            $number.focus();
        }

    });
    contactForm.find('input[name="contact[contactType]"]:checked').click();
});

function showSubjectByCategory(subjectSelectElement, category) {

    //  Définition de constants
    const SUBJECT_DEVIS = 1;
    const SUBJECT_ACHAT_VEHICULE = 2;
    const SUBJECT_COMMANDE_EN_COURS = 3;
    const SUBJECT_REPRISE = 4;
    const SUBJECT_FINANCEMENT = 5;
    const SUBJECT_SAV = 6;
    const SUBJECT_RECLAMATION = 7;
    const SUBJECT_AUTRE = 8;
    const SUBJECT_PB_TECHNIQUE = 9;

    //  Tous les sujets disponibles
    var subjects = [
        SUBJECT_DEVIS,
        SUBJECT_ACHAT_VEHICULE,
        SUBJECT_COMMANDE_EN_COURS,
        SUBJECT_REPRISE,
        SUBJECT_FINANCEMENT,
        SUBJECT_SAV,
        SUBJECT_RECLAMATION,
        SUBJECT_AUTRE,
        SUBJECT_PB_TECHNIQUE
    ];

    // sujets à garder pour la catégorie
    var selectedSubjects = [];

    // sujets à dégager
    var subjectsToRemove = [];

    switch (category) {

        case 'technique':
            selectedSubjects = [
                SUBJECT_SAV,
                SUBJECT_AUTRE,
                SUBJECT_PB_TECHNIQUE
            ];
            break;

        case 'informations':
            selectedSubjects = [
                SUBJECT_DEVIS,
                SUBJECT_ACHAT_VEHICULE,
                SUBJECT_FINANCEMENT,
                SUBJECT_SAV,
                SUBJECT_AUTRE
            ];
            break;

        case 'commande':
            selectedSubjects = [
                SUBJECT_COMMANDE_EN_COURS,
                SUBJECT_REPRISE,
                SUBJECT_SAV,
                SUBJECT_RECLAMATION,
                SUBJECT_AUTRE
            ];
            break;
    }

    //  Pour obtenir la liste des sujets à dégager,
    //  on soustrait les sujets à garder de la liste de tous les sujets
    subjectsToRemove = subjects.filter(function (el) {
        return !selectedSubjects.includes(el);
    });

    //  On parcourt et on dégage les sujets
    $.each(subjectsToRemove, function (index, value) {
        subjectSelectElement.find('optgroup:has(option[data-id="' + value + '"])').remove();
    });

}
